import {
  FeatureSection,
  PartnerSection,
  OngoingProjectSection,
  FaqSection,
  TestimonialSection,
} from "components";
import Hero from "./Hero";
import { developerFeatures } from "components/containers/constant";

const ProjectDevelopers = () => {
  return (
    <>
      <Hero />
      <PartnerSection />
      <FeatureSection features={developerFeatures} />
      <OngoingProjectSection />
      <TestimonialSection />
      <FaqSection />
    </>
  );
};
export default ProjectDevelopers;
